export * from './quiz-fixed-time.directive'


// WEBPACK FOOTER //
// /app/src/app/directives/quiz-fixed-time/index.ts